<template>
  <div>

    <div class="row row-sm">
      <div class="col-12 col-md-6 col-lg-3 col-xl-3">
        <label for="">
          {{ $t("sale7") }}
          <span class="text-danger">*</span>
        </label>

        <vue-select :options="customers" v-model="filter.customer_reference" placeholder="Select an option"
          labelColumn="fullName" valueColumn="reference" />

 
      </div>

      <div class="col-12 col-md-6 col-lg col-xl">
        <label for="">
          {{ $t("sale8") }} <span class="text-danger">*</span>
        </label>
        <input v-model="filter.startDate" type="date" class="form-control" />
      </div>
      <div class="col-12 col-md-6 col-lg col-xl">
        <label for="">
          {{ $t("sale9") }} <span class="text-danger">*</span>
        </label>
        <input v-model="filter.endDate" type="date" class="form-control" />
      </div>

      
    </div>
    <br />

    <div class="row justify-content-end">

      <div class="col-12 col-md-6 col-lg-auto col-xl-auto">
        <button @click="toFilter(filter)" class="btn btn-secondary">
          <i class="bi bi-funnel"></i>
          {{ $t("sale11") }}
        </button>
      </div>

      <div class="col-auto">
        <button @click="refresh()" class="btn btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div  class="col-auto">
        <button @click="$router.push({ name: 'orders-items-create' })" class="btn btn-primary">
          <i class="bi bi-plus-square"></i>
          Créer un commande
        </button>
      </div>
    </div>
    <br />

    <!-- <vue-data-table :headers="headers" :data="orders" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns" /> -->

    <vue-data-table :headers="headers" :data="orders" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns">

      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-validated="{ row }">
        <span class="px-2 py-1 rounded  "
          :class="row.validated == 'Validé' ? 'bg-light-success text-success' : 'bg-light-danger text-danger'">
          {{ row.validated }}
        </span>
      </template>


      <template #cell-deliveryDate="{ row }">
        <span class="px-2 py-1 rounded" :class="row.deliveryDateTime ? '' : 'bg-light-danger text-danger'">
          {{ row.deliveryDateTime ? formatDate(row.deliveryDateTime) : "Non livré" }}
        </span>
      </template>

      <template #cell-deliveryTime="{ row }">
        <span class="px-2 py-1 rounded" :class="row.deliveryDateTime ? '' : 'bg-light-danger text-danger'">
          {{ row.deliveryDateTime ? formatTime(row.deliveryDateTime) : "Non livré" }}
        </span>
      </template>


      <template #cell-vehicleFullName="{ row }">
        <span class="px-2 py-1 rounded  " :class="row.vehicleFullName ? '' : 'bg-light-danger text-danger'">
          {{ row.vehicleFullName ? row.vehicleFullName : "Non livré" }}
        </span>
      </template>


      <template #cell-remark="{ row }">
        <span v-show="row.remark" class="px-2 py-1 rounded  " :class="row.remark ? 'bg-light-info text-info' : ''">
          <i class="bi bi-exclamation-circle-fill"></i>
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span v-show="$userRole != 'Magasinier'" class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>


    </vue-data-table>

  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      filter: {
        customer_reference: null,
        startDate: null,
        endDate: null,
      },
      search_value: "",
      addedToday: false,
      sortValue: "",
      selections: [],
      headers: [
        { field: 'reference', label: 'Référence', class: '' },
        { field: 'customerFullName', label: 'Nom Complet', class: '' },
        { field: 'date', label: 'Date', class: '' },
        { field: 'totalPriceTTC', label: ' Total', class: 'fw-bold', isAmount: true },
        { field: 'totalQuantity', label: 'Total Qté', class: 'fw-bold' },
        { field: 'passPermit', label: 'Bon Nº', class: '' },
        { field: 'remark', label: 'NB', class: '' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      // Button actions
      buttons: [
        {
          label: 'Détails',
          icon: 'bi bi-info-square',
          class: 'btn btn-primary',
          action: (order) => {
            this.$router.push({
              name: 'orders-details',
              params: { reference: order.reference },
            });
          },
        },
      ],
      // Summable columns
      summableColumns: [
        { field: 'totalPriceTTC', class: 'fw-bold' },
        { field: 'totalQuantity', class: 'fw-bold' },
      ],

    };
  },
  computed: {
    ...mapGetters("order", {
      allOrders: "getAll",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    orders() {
      if (this.$userRole === "Magasinier") {
        return this.allOrders;
        // return this.allOrders.filter(order => order.validated !== "Validé");
      }
      return this.allOrders;
    },
  },

  created() {
    this.$store.dispatch("customer/getAll");

  },

  mounted() {

    if (this.$route.query.customer_reference || this.$route.query.startDate || this.$route.query.endDate) {
      const filterData = {
        customer_reference: this.$route.query.customer_reference || null,
        startDate: this.$route.query.startDate || null,
        endDate: this.$route.query.endDate || null,
      };

      this.filter = filterData;

      this.toFilter(filterData);
    } else {
      this.$store.dispatch("order/getAll");
    }

  },
  methods: {

    async refresh() {
      await this.$store.dispatch("order/getAll");
    },

    async printManyPurchaseOrder(data) {
      await this.$store.dispatch("order/printManyPurchaseOrderPage", data);
    },

    async toFilter(data) {
      await this.$store.dispatch("order/filter", data);
      await this.$router.push({
        name: "orders-index", query: {
          customer_reference: data.customer_reference,
          startDate: data.startDate,
          endDate: data.endDate,
        }
      });
    },

    formatDate(value) {
      if (!value) return null;
      return moment(value).format("DD-MM-YYYY");
    },
    formatTime(value) {
      if (!value) return null;
      return moment(value).format("HH:mm"); // Correction du format d'heure
    }
  },


};
</script>
